import React from 'react';
import { useAuthorization } from '@/auth/hooks/useAuthorization';
import { useSubtramiteForm } from '../../../hooks/useSubtramiteForm';
import { saveMunicipalidad } from '../../../services/tramiteService';
import SubtramiteForm from '../../SubtramiteForm';
import { validaTiempo } from '../../../utils/validaciones';
import { withRequiredTramite } from './withRequiredTramite';

const Municipalidad: React.FC = () => {
  const {
    data,
    loading,
    init,
    isUpdate,
    setIsUpdate,
    handleChange,
    handleSubmit,
    handleFinalizarSubtramite,
    handleReabrirSubtramite
  } = useSubtramiteForm({
    subtramiteKey: 'municipalidad',
    defaultData: {
      habilitado: true,
      fecini: new Date(),
      cuenta: null,
      distrito: null,
      boleto: null,
      recibo: null,
      libredeuda: null,
      boleto_path: null,
      recibo_path: null,
      libredeuda_path: null,
    },
    saveFunction: saveMunicipalidad,
    successMessage: 'Municipalidad Guardado con éxito',
    errorTitle: 'Error al grabar Municipalidad',
  });

  const { canManageTramites, canUploadTramitesFiles } = useAuthorization();

  // Configuración de campos básicos
  const fields = [
    {
      type: 'toggle',
      name: 'habilitado',
      label: 'Habilitado:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
    {
      type: 'text',
      name: 'cuenta',
      label: 'Cuenta:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
    {
      type: 'text',
      name: 'distrito',
      label: 'Departamento:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
    {
      type: 'date',
      name: 'fecini',
      label: 'Fecha de inicio:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
  ];

  // Configuración de campos de archivos
  const fileFields = [
    {
      type: 'file',
      name: 'boleto',
      label: 'Boleto:',
      pathField: 'boleto_path',
      visible: isUpdate,
      readOnly: !canUploadTramitesFiles,
      helpText: 'Acción a realizar por la tramitadora',
    },
    {
      type: 'file',
      name: 'recibo',
      label: 'Recibo:',
      pathField: 'recibo_path',
      visible: isUpdate,
      readOnly: !(canManageTramites || (canUploadTramitesFiles && validaTiempo(data.recibo_path, data.recibo_udt))),
      helpText: `Acción a realizar por el vendedor o la tramitadora.
              Puede realizar el pago del boleto en Bolsa de comercio, PagoFácil, RapiPago, Banco Nación o cualquier entidad autorizada.`,
    },
    {
      type: 'file',
      name: 'libredeuda',
      label: 'Libre deuda y transferencia:',
      pathField: 'libredeuda_path',
      visible: isUpdate,
      readOnly: !canUploadTramitesFiles,
      helpText: 'Acción a realizar por la tramitadora',
    },
  ];

  const btnGuardarVisible = fields.some(field => field.visible) ||
    fileFields.some(field => field.visible && !field.readOnly);


  return (
    <SubtramiteForm
      title="Municipalidad"
      data={data}
      loading={loading}
      init={init}
      isUpdate={isUpdate}
      setIsUpdate={setIsUpdate}

      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleFinalizarSubtramite={handleFinalizarSubtramite}
      handleReabrirSubtramite={handleReabrirSubtramite}
      btnGuardarVisible={btnGuardarVisible}
      fields={fields}
      fileFields={fileFields}
      subtramiteKey="municipalidad"
    />
  );
}

export default withRequiredTramite(Municipalidad);
